import React, { memo } from 'react'

import { graphql } from 'gatsby'

import Img from '../components/Img'
import ContactForm from '../components/contactForm'

const TitleBlock = ({ className, primary }) => (
  <div className={`contact-form-rewards-section--box ${className}`}>
    <h2 className="title">{primary?.title1?.text}</h2>
    <p className="p p-16">{primary?.description1?.text}</p>
  </div>
)

const ContactFormWithRewardsSection = ({ slice, context }) => {
  const { primary, items } = slice

  return (
    <section
      className={`section contact-form-rewards-section ${primary?.page}`}
    >
      <div className="container">
        <TitleBlock className="mobile-form" primary={primary} />
        <ContactForm className="contact-form" data={context.contactFormData} />
        <div className="rewards-block">
          <TitleBlock primary={primary} />
          <div className="rewards-box">
            {items.map((item) => (
              <div key={item} className="reward-item">
                <Img
                  image={item?.reward_image?.gatsbyImageData}
                  alt={item?.alt}
                  className="image"
                />
                <p className="p p-16 p-title">{item?.reward_title?.text}</p>
                <p className="p p-16 p-description">
                  {item?.reward_description?.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default memo(ContactFormWithRewardsSection)

export const query = graphql`
  fragment StoryPageDataBody1StoryContactFormSection on PrismicStoryPageDataBody1StoryContactFormSection {
    id
    items {
      reward_description {
        text
      }
      reward_image {
        gatsbyImageData
        alt
      }
      reward_title {
        text
      }
    }
    primary {
      title1 {
        text
      }
      description1 {
        text
      }
    }
  }
  fragment PricePageDataBodyStoryContactFormSection on PrismicPricePageDataBodyStoryContactFormSection {
    id
    items {
      reward_description {
        text
      }
      reward_image {
        gatsbyImageData
        alt
      }
      reward_title {
        text
      }
    }
    primary {
      title1 {
        text
      }
      description1 {
        text
      }
    }
  }
`
